module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/logo_visadebito.092f0267.png";